import {Button, Card, CardBody, Col, Input, Label, Row, Spinner, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {ADMIN_PATHS, REPORT_PROCEEDING_PATHS} from "../../config";
import React, {useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {useTranslation} from "react-i18next";
import {CheckUserRole} from "../../AppSystem/Helpers/CheckUserRole";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import $ from "jquery";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import {UserProfileHeader} from "../../Common/Components/User/UserProfileHeader";
import {UserSystemRoles} from "../../Common/Components/User/UserSystemRoles";
import {UserOrgRoles} from "../../Common/Components/User/UserOrgRoles";
import {CustomReload} from "../../AppSystem/Helpers/CustomReload";
import {CustomModal} from "../../Common/Components/Modal/CustomModal";
import classnames from "classnames";
import { ChangeDateFormat } from "../../Common/Helpers/ChangeDateFormat";
import { PendingBankTransferList } from "../../BankTransfers/Views/PendingBankTransferList";
import AdminHonorariumList from "../../Honorarium/Views/AdminHonorariumList";
import ReportProceedingList from "../../Reimbursement/Views/ReportProceedingList";
import AdminHonorariumListHistory from "../../Honorarium/Views/AdminHonorariumListHistory";
import { BankTransferHistoryList } from "../../BankTransfers/Views/BankTransferHistoryList";
import { useSelector } from "react-redux";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";
import { FlashMessage } from "../../Common/Helpers/FlashMessage";

export function AdminUserInfo() {
    const [activeTab, setActiveTab] = useState('1');

    const { rolesData } = useSelector(state => state.auth);
    const isSuperAdmin = CheckUserRole(rolesData, "SuperAdmin");
    const { ApiCall } = useApiCallService();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const idValue = new URLSearchParams(window.location.search).get('id');
    const isMobile = CheckMobile(998);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    const tabsNavStyle = {
        borderBottom: 'none',
        ...(isMobile
            ? {
                flexWrap: 'nowrap',
                overflowX: 'auto',
                overflowY: 'hidden',
                WebkitOverflowScrolling: 'touch',
                paddingBottom: '0.25rem',
                gap: '0.25rem'
            }
            : {})
    };

    const tabNavItemStyle = isMobile ? { flex: '0 0 auto' } : undefined;

    const getTabLinkStyle = (tabId) => ({
        cursor: "pointer",
        backgroundColor: activeTab === tabId ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
        borderColor: activeTab === tabId ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
        whiteSpace: 'nowrap'
    });

    const [apiResponseRoleList, setApiResponseRoleList] = useState(null);
    const [apiResponseUser, setApiResponseUser] = useState(null);
    const [apiResponseRoleOrgList, setApiResponseRoleOrgList] = useState(null);
    const [apiResponseUserCostPlaceList, setApiResponseUserCostPlaceList] = useState(null);

    const [bankSignaturePnr, setBankSignaturePnr] = useState("");
    const [isSavingBankSignaturePnr, setIsSavingBankSignaturePnr] = useState(false);
    const [isEditingBankSignaturePnr, setIsEditingBankSignaturePnr] = useState(false);

    useEffect(() => {
        if (apiResponseUser) {
            if (apiResponseUser.firstName && apiResponseUser.lastName) {
                setPageTitle(apiResponseUser.firstName + ' ' + apiResponseUser.lastName);
                setPageTitleKey('modelLabel.adminUserInfo');
            }
            if (apiResponseUser.bankSignaturePnr !== undefined) {
                setBankSignaturePnr(apiResponseUser.bankSignaturePnr || "");
            }
        }
        setOnBack(handleBackButtonClick);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t, apiResponseUser]);

    // Tab show flags -> used to defer loading data until tab is shown
    const [showTab1, setShowTab1] = useState(true); // personal info should load immediately
    const [showTab2, setShowTab2] = useState(false);
    const [showTab3, setShowTab3] = useState(false);
    const [showTab4, setShowTab4] = useState(false);
    const [showTab5, setShowTab5] = useState(false);
    const [showTab6, setShowTab6] = useState(false);
    const [showTab7, setShowTab7] = useState(false);

    // ASSIGN ROLE
    const [assignRoleList, setAssignRoleList] = useState([]);
    const [requestAssignRole, setRequestAssignRole] = useState(null);
    const [responseAssignRole, setResponseAssignRole] = useState(null);

    // ASSIGN ORG
    const [userOrgList, setUserOrgList] = useState([]);
    const [orgLeabList, setOrgLeabList] = useState(null);
    const [requestAssignOrg, setRequestAssignOrg] = useState(null);
    const [responseAssignOrg, setResponseAssignOrg] = useState(null);

    // ASSIGN COST PLACE
    const [assignCostPlaceList, setAssignCostPlaceList] = useState(null);
    const [responseCostPlaceList, setResponseCostPlaceList] = useState(null);
    const [responseCostPlace, setResponseCostPlace] = useState(null);

    // DELETE USER
    const [requestDelete, setRequestDelete] = useState(null);
    const [responseDelete, setResponseDelete] = useState(null);
    const [displayDeleteModal, setDisplayDeleteModal] = useState(false);

    // ACTIVE USER
    const [requestActive, setRequestActive] = useState(null);
    const [responseActive, setResponseActive] = useState(null);
    const [displayActiveModal, setDisplayActiveModal] = useState(false);

    let permission = false;
    if (CheckUserPermission("system") || CheckUserPermission("system.setting") || CheckUserPermission("system.setting.role") || CheckUserPermission("system.setting.role.assign")) {
        permission = true;
    }

    let permissionOrg = false;
    if (CheckUserPermission("system") || CheckUserPermission("system.user") || CheckUserPermission("system.user.assign")) {
        permissionOrg = true;
    }

    let permissionDelete = false;
    if (CheckUserPermission("system") || CheckUserPermission("system.user") || CheckUserPermission("system.user.delete")) {
        permissionDelete = true;
    }
    let permissionActive = false;
    if (CheckUserPermission("system") || CheckUserPermission("system.user") || CheckUserPermission("system.user.active")) {
        permissionActive = true;
    }

    const location = useLocation();
    
    const completePath = location.pathname + location.search;

    const handleBackButtonClick = () => {
        const from = location.state?.from;
        if (from === "organization-list") {
            navigate(`${ADMIN_PATHS.ADMIN_ORGANIZATION_INFO}?id=${location.state.organizationId}`);
        } else if (from === "tax-authority-report") {
            const idItem = location.state?.idItem;
            
            navigate(`${ADMIN_PATHS.ADMIN_REPORT_TAX_INFO}${idItem ? `?id=${idItem}` : ''}`, {
                state: {
                    markdownValue: location.state?.markdownValue,
                    idItem: idItem
                }
            });
        } else {
            navigate(ADMIN_PATHS.ADMIN_USER);
        }
    };

    // cuando cambia activeTab, marcamos la pestaña para que se muestre/ejecute la primera vez
    useEffect(() => {
        if (activeTab === '1') setShowTab1(true);
        if (activeTab === '2') setShowTab2(true);
        if (activeTab === '3') setShowTab3(true);
        if (activeTab === '4') setShowTab4(true);
        if (activeTab === '5') setShowTab5(true);
        if (activeTab === '6') setShowTab6(true);
        if (activeTab === '7') setShowTab7(true);
    }, [activeTab]);

    useEffect(() => {
        const handleApiResponseUserInfo  = (apiResponseUser) => {
            setApiResponseUser(apiResponseUser);
        };
        const GetInfoUser = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/user/admin?id=${idValue}`,
                    };
                    await ApiCall(apiCallOptions, handleApiResponseUserInfo );
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        GetInfoUser();
    }, [idValue]);

    const HandleSaveBankSignaturePnr = async () => {
        if (!bankSignaturePnr || bankSignaturePnr.length !== 12) {
            FlashMessage(t('validationMessage.bankSignaturePnrLength'), 'flash-messageError');
            return;
        }
        setIsSavingBankSignaturePnr(true);
        const handleResponseUpdateBankSignaturePnr = (response) => {
            setIsSavingBankSignaturePnr(false);
            if (response) {
                setApiResponseUser(response);
                if (response.bankSignaturePnr !== undefined) {
                    setBankSignaturePnr(response.bankSignaturePnr || "");
                }
                setIsEditingBankSignaturePnr(false);
                FlashMessage(t('validationMessage.bankSignaturePnrUpdate'), 'flash-messageSuccess');
            } else {
                FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
            }
        };
        try {
            const apiCallOptions = {
                method: "put",
                url: "/user",
                data: {
                    userId: apiResponseUser.id,
                    bankSignaturePnr: bankSignaturePnr
                }
            };
            await ApiCall(apiCallOptions, handleResponseUpdateBankSignaturePnr);
        } catch (error) {
            setIsSavingBankSignaturePnr(false);
            console.log('error updating bank signature pnr', error);
            FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
        }
    };

    // Roles list - defer until tab 2 is shown
    useEffect(() => {
        if (!showTab2) return;
        const handleApiResponse  = (apiResponseRoleList) => {
            setApiResponseRoleList(apiResponseRoleList);
        };
        const GetUserRole = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/user/admin/role/list?id=${idValue}`,
                    };
                    await ApiCall(apiCallOptions, handleApiResponse );
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        GetUserRole();
    }, [idValue, showTab2]);

    // list Organization - defer until tab 2 is shown
    useEffect(() => {
        if (!showTab2) return;
        const handleApiResponseListAll  = (apiResponseRoleOrgList) => {
            setApiResponseRoleOrgList(apiResponseRoleOrgList);
        };
        const GetOrgRole = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/user/role/org/list/all?id=${idValue}`, // change the call when in the api
                    };
                    await ApiCall(apiCallOptions, handleApiResponseListAll );
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        GetOrgRole();
    }, [idValue, showTab2]);

    ////////// ASSIGN ROLE LIST - defer until tab 2
    useEffect(() => {
        if (!showTab2) return;
        const handleAssignRoleList  = (response) => {
            setAssignRoleList(response);
        };
        const GetAssignRoleList = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/role/admin/user/list",
                    };
                    await ApiCall(apiCallOptions, handleAssignRoleList);
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        GetAssignRoleList();
    }, [idValue, showTab2]);

    // CHECK ROLES
    useEffect(() => {
        if (apiResponseRoleList && apiResponseRoleList.length > 0) {
            setRequestAssignRole((prevFormData) => ({
                ...prevFormData,
                userId: idValue,
                roles: apiResponseRoleList.map((item) => item.role)
            }));
        }
    }, [apiResponseRoleList]);

    // HANDLE CLICK ASSIGN ROLE
    const HandleClickAssignRole = (e) => {
        let roles = requestAssignRole.roles;
        if (e.target.checked) {
            roles.push(e.target.value);
        } else {
            roles = roles.filter((item) => item !== e.target.value);
        }
        setRequestAssignRole((prevFormData) => ({
            ...prevFormData,
            roles: roles
        }));
    }

    // HANDLE SUBMIT ASSIGN ROLE
    const HandleSubmitAssignRole = async () => {
        const handleSendAssignRole = (response) => {
            setResponseAssignRole(response);
        }
        const apiCallOptions = {
            method: "put",
            url: "/role/admin/assign/user",
            data: requestAssignRole
        };
        await ApiCall(apiCallOptions, handleSendAssignRole);
    }

    // RESPONSE ASSIGN ROLE
    useEffect(() => {
        if (responseAssignRole !== null) {
            CustomReload();
        }
    }, [responseAssignRole]);

    ////////// LEAB ORG LIST - defer until tab 2
    useEffect(() => {
        if (!showTab2) return;
        const handleUserOrgList  = (response) => {
            setUserOrgList(response);
        };
        const GetUserOrgList = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/user/admin/org-list?id=" + idValue,
                    };
                    await ApiCall(apiCallOptions, handleUserOrgList);
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        GetUserOrgList();
    }, [idValue, showTab2]);

    // org list - defer until tab 2
    useEffect(() => {
        if (!showTab2) return;
        const handleOrgList  = (response) => {
            setOrgLeabList(response);
        };
        const GetOrgList = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/org/admin/leab",
                    };
                    await ApiCall(apiCallOptions, handleOrgList);
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        GetOrgList();
    }, [idValue, showTab2]);

    // CHECK ORGS
    useEffect(() => {
        const filteredUserOrgs = [];
        if (userOrgList && userOrgList.length > 0 && orgLeabList && orgLeabList.length > 0) {
            // CHECK IF USER HAS SOME LEAB ORG
            userOrgList.filter((userOrg) => {
                orgLeabList.some((org) => {
                    if (org.id === userOrg.id) {
                        filteredUserOrgs.push(org.id);
                    }
                })
            });
        }
        setRequestAssignOrg((prevFormData) => ({
            ...prevFormData,
            userId: idValue,
            orgIds: filteredUserOrgs
        }));
        setRequestDelete((prevFormData) => ({
            ...prevFormData,
            id: idValue
        }));
        setRequestActive((prevFormData) => ({
            ...prevFormData,
            id: idValue
        }));
    }, [userOrgList, orgLeabList]);

    // HANDLE CLICK ASSIGN ORG
    const HandleClickAssignOrg = (e) => {
        let orgIds = requestAssignOrg.orgIds;
        if (e.target.checked) {
            orgIds.push(e.target.value);
        } else {
            orgIds = orgIds.filter((item) => item !== e.target.value);
        }
        setRequestAssignOrg((prevFormData) => ({
            ...prevFormData,
            orgIds: orgIds
        }));
    }

    // HANDLE SUBMIT ASSIGN ORG
    const HandleSubmitAssignOrg = async () => {
        const handleSendAssignOrg = (response) => {
            setResponseAssignOrg(response);
        }
        const apiCallOptions = {
            method: "put",
            url: "/user/admin/assign/org",
            data: requestAssignOrg
        };
        await ApiCall(apiCallOptions, handleSendAssignOrg);
    }

    // RESPONSE ASSIGN ORG
    useEffect(() => {
        if (responseAssignOrg !== null) {
            CustomReload();
        }
    }, [responseAssignOrg]);

    ////////// COST PLACE LIST - defer until tab 2
    // GET ALL COST PLACES
    useEffect(() => {
        if (!showTab2) return;
        const handleCostPlaceList  = (response) => {
            if (!response || !Array.isArray(response)) {
                setResponseCostPlaceList({});
                return;
            }
            const groupedCostPlaceList = response.reduce((acc, item) => {
                const [category, id, name] = item.split(" - ");
                if (!acc[category]) acc[category] = [];
                acc[category].push({ id, name });
                return acc;
            }, {});
            setResponseCostPlaceList(groupedCostPlaceList);
        };
        const GetCostPlaceList = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/org/admin/cost-place?userId=" + idValue,
                };
                await ApiCall(apiCallOptions, handleCostPlaceList);
            } catch (error) {
                console.log('error', error);
            }
        };
        GetCostPlaceList();
    }, [idValue, showTab2]);

    // GET USER COST PLACES - defer until tab 2
    useEffect(() => {
        if (!showTab2) return;
        const handleUserCostPlaceList  = (response) => {
            setApiResponseUserCostPlaceList(response);
        };
        const GetUserCostPlaceList = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/usersetting/primary-costplace?id=" + idValue,
                    };
                    await ApiCall(apiCallOptions, handleUserCostPlaceList);
                } catch (error) {
                    console.log('error', error);
                }
            }
        };
        GetUserCostPlaceList();
    }, [idValue, showTab2]);

    // CHECK COST PLACES
    useEffect(() => {
        if (apiResponseUserCostPlaceList && apiResponseUserCostPlaceList.primaryCostPlaces && apiResponseUserCostPlaceList.primaryCostPlaces.length > 0) {
            setAssignCostPlaceList((prevFormData) => ({
                ...prevFormData,
                id: idValue,
                primaryCostPlace: apiResponseUserCostPlaceList.primaryCostPlaces
            }));
        }
    }, [apiResponseUserCostPlaceList]);

    // HANDLE CLICK ASSIGN COST PLACE
    const HandleClickAssignCostPlace = (e) => {
        let costPlaces = assignCostPlaceList?.primaryCostPlace ?? [];
        if (e.target.checked) {
            costPlaces.push(e.target.value);
        } else {
            costPlaces = costPlaces.filter((item) => item !== e.target.value);
        }
        setAssignCostPlaceList((prevFormData) => ({
            ...prevFormData,
            primaryCostPlace: costPlaces
        }));
    }

    // HANDLE SUBMIT ASSIGN COST PLACE
    const HandleSubmitAssignCostPlace = async () => {
        const handleSendAssignCostPlace = (response) => {
            setResponseCostPlace(response);
        }
        assignCostPlaceList.id = idValue;
        const apiCallOptions = {
            method: "post",
            url: "/usersetting/primary-costplace",
            data: assignCostPlaceList
        };
        await ApiCall(apiCallOptions, handleSendAssignCostPlace);
    }

    // RESPONSE ASSIGN COST PLACE
    useEffect(() => {
        if (responseCostPlace !== null) {
            CustomReload();
        }
    }, [responseCostPlace]);

    ////////// DELETE USER
    // HANDLE SUBMIT DELETE USER
    const HandleSubmitDeleteUser = async () => {
        const handleSendDelete = (response) => {
            setResponseDelete(response);
        }
        const apiCallOptions = {
            method: "delete",
            url: "/user/admin/",
            data: requestDelete
        };
        await ApiCall(apiCallOptions, handleSendDelete);
    }

    // RESPONSE DELETE USER
    useEffect(() => {
        if (responseDelete !== null) {
            CustomReload();
        }
    }, [responseDelete]);

    // MODAL DELETE USER
    const HandleClickTrash = () => {
        setDisplayDeleteModal(true);
    }
    const modalContentDelete = (
        <div>
            {`${t('validationMessage.deleteUser')}`}
        </div>
    );
    const modalFooterDelete = (
        <>
            <Button id="deleteButton" className="box-green border-0" onClick={() => {
                $("#deleteButton").prop('disabled', true);
                HandleSubmitDeleteUser();
            }}>
                {t('button.delete')}
            </Button>
            <Button className="box-red border-0" onClick={() => setDisplayDeleteModal(false)}>{t('button.cancel')}</Button>
        </>
    );

    ////////// ACTIVE USER
    // HANDLE SUBMIT ACTIVE USER
    const HandleSubmitActiveUser = async () => {
        const handleSendActive = (response) => {
            setResponseActive(response);
        }
        const apiCallOptions = {
            method: "post",
            url: "/user/admin/",
            data: requestActive
        };
        await ApiCall(apiCallOptions, handleSendActive);
    }

    // RESPONSE ACTIVE USER
    useEffect(() => {
        if (responseActive !== null) {
            CustomReload();
        }
    }, [responseActive]);

    // MODAL ACTIVE USER
    const HandleClickActive = () => {
        setDisplayActiveModal(true);
    }
    const modalContentActive = (
        <div>
            {`${t('validationMessage.activeUser')}`}
        </div>
    );
    const modalFooterActive = (
        <>
            <Button id="activeButton" className="box-green border-0" onClick={() => {
                $("#activeButton").prop('disabled', true);
                HandleSubmitActiveUser();
            }}>
                {t('button.accept')}
            </Button>
            <Button className="box-red border-0" onClick={() => setDisplayActiveModal(false)}>{t('button.cancel')}</Button>
        </>
    );

    return(
        <>
            {!isMobile && (
                <Col lg={1} className="px-0">
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'ms-2 mb-3 rounded'}
                        onClick={handleBackButtonClick}
                    />
                </Col>
            )}

            {apiResponseUser ? (
                <>
                    <Col lg={12} className="px-0">
                        <UserProfileHeader
                            data={apiResponseUser}
                            isSuperAdmin={isSuperAdmin}
                            type="Admin"
                            handleClickTrash={HandleClickTrash}
                            handleClickActive={HandleClickActive}
                            minimal={true}
                        />

                        {/* MODALES */}
                        {apiResponseUser.status !== "Raderad" && permissionDelete && (
                            <CustomModal
                                isOpen={displayDeleteModal}
                                toggle={() => setDisplayDeleteModal(!displayDeleteModal)}
                                body={modalContentDelete}
                                footer={modalFooterDelete}
                            />
                        )}

                        {apiResponseUser.status === "Raderad" && permissionActive && (
                            <CustomModal
                                isOpen={displayActiveModal}
                                toggle={() => setDisplayActiveModal(!displayActiveModal)}
                                body={modalContentActive}
                                footer={modalFooterActive}
                            />
                        )}

                        <Row className="justify-content-center" style={{ position: 'relative', zIndex: 10 }}>
                            <Col lg={12} className="px-4 p-lg-5 padding-top-profile">
                                {/* === TABS === */}
                                <Nav tabs className="mb-3" style={tabsNavStyle}>
                                    <NavItem style={tabNavItemStyle}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' }, "text-white-50")}
                                            onClick={() => setActiveTab('1')}
                                            style={getTabLinkStyle('1')}
                                        >
                                            {t('adminLabel.personalInfo')}
                                        </NavLink>
                                    </NavItem>

                                    {/* Combined tab: Roles + Organizations + Cost Places */}
                                    <NavItem style={tabNavItemStyle}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' }, "text-white-50")}
                                            onClick={() => setActiveTab('2')}
                                            style={getTabLinkStyle('2')}
                                        >
                                            {t('adminLabel.roles')}
                                        </NavLink>
                                    </NavItem>

                                    <NavItem style={tabNavItemStyle}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' }, "text-white-50")}
                                            onClick={() => setActiveTab('3')}
                                            style={getTabLinkStyle('3')}
                                        >
                                            {t('sidebar.reimbursement')}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem style={tabNavItemStyle}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '4' }, "text-white-50")}
                                            onClick={() => setActiveTab('4')}
                                            style={getTabLinkStyle('4')}
                                        >
                                            {t('sidebar.honorarium')}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem style={tabNavItemStyle}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '5' }, "text-white-50")}
                                            onClick={() => setActiveTab('5')}
                                            style={getTabLinkStyle('5')}
                                        >
                                            {t('sidebar.bankTransfers')}
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab}>
                                    {/* TAB 1 - PERSONAL INFO */}
                                    <TabPane tabId="1">
                                        <Card className="mb-5 card-backend">
                                            <CardBody>
                                                <h5 className="mb-3 text-green fw-bold">{t('adminLabel.personalInfo')}</h5>
                                                {apiResponseUser && (
                                                    <Row className="mb-2">
                                                        {isSuperAdmin && (
                                                            <Col lg={6} className="mb-2">
                                                                <Label className="fw-bold">{t('modelLabel.id')}</Label>
                                                                <div>{apiResponseUser.id}</div>
                                                            </Col>
                                                        )}
                                                        {apiResponseUser.visualId && (
                                                            <Col lg={6} className="mb-2">
                                                                <Label className="fw-bold">{t('modelLabel.id')}</Label>
                                                                <div>{apiResponseUser.visualId}</div>
                                                            </Col>
                                                        )}
                                                        {apiResponseUser.pnr && (
                                                            <Col lg={6} className="mb-2">
                                                                <Label className="fw-bold">{t('modelLabel.pnr')}</Label>
                                                                <div>{apiResponseUser.pnr}</div>
                                                            </Col>
                                                        )}
                                                        {apiResponseUser.email && (
                                                            <Col lg={6} className="mb-2">
                                                                <Label className="fw-bold">{t('modelLabel.email')}</Label>
                                                                <div>{apiResponseUser.email}</div>
                                                            </Col>
                                                        )}
                                                        {apiResponseUser.phone && (
                                                            <Col lg={6} className="mb-2">
                                                                <Label className="fw-bold">{t('modelLabel.phone')}</Label>
                                                                <div>{apiResponseUser.phone}</div>
                                                            </Col>
                                                        )}
                                                        {apiResponseUser.loggedOnLastTime && (
                                                            <Col lg={6} className="mb-2">
                                                                <Label className="fw-bold">{t('modelLabel.lastLogin')}</Label>
                                                                <div>{ChangeDateFormat('dateTime', apiResponseUser.loggedOnLastTime)}</div>
                                                            </Col>
                                                        )}
                                                        <Col lg={6} className="mb-2">
                                                            <Label className="fw-bold">{t('modelLabel.country')}</Label>
                                                            <div>{t('modelLabel.sweden')}</div>
                                                        </Col>
                                                        {isSuperAdmin && (
                                                            <Col lg={6} className="mb-2">
                                                                <Label className="fw-bold">{t('modelLabel.bankSignaturePnr')}</Label>
                                                                {apiResponseUser.bankSignaturePnr && !isEditingBankSignaturePnr ? (
                                                                    <div className="d-flex align-items-center">
                                                                        <div>{apiResponseUser.bankSignaturePnr}</div>
                                                                        <CustomButton
                                                                            text=""
                                                                            icon="bx bx-edit py-1"
                                                                            iconColor="#157553"
                                                                            iconSize={5}
                                                                            buttonColor="#D0ECE3"
                                                                            buttonRadius={3}
                                                                            hoverButtonRadius={3}
                                                                            hoverIconColor="white"
                                                                            hoverButtonColor="#157553"
                                                                            customClasses="border-0 ms-2"
                                                                            onClick={() => setIsEditingBankSignaturePnr(true)}
                                                                            tooltipText={t('button.edit')}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex align-items-center">
                                                                        <Input
                                                                            id="bankSignaturePnr"
                                                                            type="text"
                                                                            className="form-control me-2"
                                                                            placeholder="yyyymmdd-xxxx"
                                                                            maxLength={12}
                                                                            style={{ maxWidth: '170px' }}
                                                                            value={bankSignaturePnr}
                                                                            disabled={isSavingBankSignaturePnr}
                                                                            onChange={(e) => {
                                                                                const value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                                                                setBankSignaturePnr(value);
                                                                            }}
                                                                        />
                                                                        <CustomSubmitButton
                                                                            id="submitBankSignaturePnr"
                                                                            text=""
                                                                            icon="bx bx-save"
                                                                            disabled={isSavingBankSignaturePnr}
                                                                            customClick={async () => {
                                                                                await HandleSaveBankSignaturePnr();
                                                                            }}
                                                                            tooltipText={t('button.save')}
                                                                        />
                                                                        {apiResponseUser.bankSignaturePnr && (
                                                                            <CustomButton
                                                                                text=""
                                                                                icon="bx bx-x py-1"
                                                                                iconColor="#EB5757"
                                                                                iconSize={5}
                                                                                buttonColor="#e9cbcd"
                                                                                buttonRadius={3}
                                                                                hoverButtonRadius={3}
                                                                                hoverIconColor="white"
                                                                                hoverButtonColor="#EB5757"
                                                                                customClasses="border-0 ms-1"
                                                                                onClick={() => {
                                                                                    setIsEditingBankSignaturePnr(false);
                                                                                    setBankSignaturePnr(apiResponseUser.bankSignaturePnr || "");
                                                                                }}
                                                                                tooltipText={t('button.cancel')}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Col>
                                                        )}
                                                    </Row>
                                                )}
                                            </CardBody>
                                        </Card>
                                    </TabPane>

                                    {/* TAB 2 - COMBINED: ROLES + ORGANIZATIONS + COST PLACES */}
                                    <TabPane tabId="2">
                                        {showTab2 && (
                                        <Row>
                                            <Col lg={6}>
                                                {/* SYSTEM ROLES */}
                                                {apiResponseRoleList ?
                                                    <UserSystemRoles data={apiResponseRoleList} />
                                                : ''}
                                                {/* ORGANIZATION ROLES */}
                                                {apiResponseRoleOrgList ?
                                                    <UserOrgRoles data={apiResponseRoleOrgList} isSuperAdmin={isSuperAdmin} />
                                                : ''}
                                            </Col>
                                            <Col lg={6}>
                                                {/* ASSIGN ROLES */}
                                                {assignRoleList && assignRoleList.length > 0 && permission ?
                                                    <Card className={(orgLeabList && orgLeabList.length > 0 && permissionOrg) || (responseCostPlaceList && Object.keys(responseCostPlaceList).length > 0 && permission) ? "mb-3 card-backend" : "mb-5 card-backend"}>
                                                        <CardBody>
                                                            <h5 className="mb-3 text-green fw-bold">{t('adminLabel.assignRoles')}</h5>
                                                            <Row>
                                                                {assignRoleList.map((item) => {
                                                                    if (requestAssignRole !== null && requestAssignRole.roles && requestAssignRole.roles.length > 0 && requestAssignRole.roles.indexOf(item.role) !== -1) {
                                                                        setTimeout(() => {
                                                                            $(`#role${item.id}`).prop('checked', true);
                                                                        }, 250);
                                                                    }
                                                                    return (
                                                                        <div className="col-6">
                                                                            <Label>
                                                                                <Input id={`role${item.id}`} type="checkbox" name="role" value={item.role} disabled={item.role === "Förtroendevald"} onChange={(e) => HandleClickAssignRole(e)} />
                                                                                <span className="ms-2">{item.role}</span>
                                                                            </Label>
                                                                            {item.permissions && item.permissions.length > 0 ?
                                                                                <>
                                                                                    <i className="ms-2 bx bx-info-circle fs-5 text-green"
                                                                                    onMouseOverCapture={() => {
                                                                                        $("#permissionDiv").removeClass("d-none");
                                                                                        $("#permissionSpan").text(item.permissions.join(', '));
                                                                                    }}
                                                                                    onMouseOutCapture={() => {
                                                                                        $("#permissionDiv").addClass("d-none");
                                                                                        $("#permissionSpan").text("");
                                                                                    }}
                                                                                    />
                                                                                </>
                                                                            : ''}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </Row>
                                                            <div id="permissionDiv" className="mt-1 mb-3 bg-orange-light rounded border border-warning text-warning p-2 d-none text-center">
                                                                <h6>{t('role.permissions')}</h6>
                                                                <span id="permissionSpan"></span>
                                                            </div>
                                                            <div className="text-end">
                                                                <span id="spinnerAssign" className="me-3 d-none">
                                                                    {t('validationMessage.assigningRoles')} <Spinner color='success'/>
                                                                </span>
                                                                <CustomSubmitButton id="submitAssign" text={t("button.assign")} icon="bx bx-send pe-2"
                                                                                    customClick={async () => {
                                                                                        $("#submitAssign").prop('disabled', true);
                                                                                        $("#spinnerAssign").removeClass("d-none");
                                                                                        await HandleSubmitAssignRole();
                                                                                    }}/>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                    : ''}
                                                {/* ASSIGN ORG */}
                                                {orgLeabList && orgLeabList.length > 0 && permissionOrg ?
                                                    <Card className={responseCostPlaceList && Object.keys(responseCostPlaceList).length > 0 && permission ? "mb-3 card-backend" : "mb-5 card-backend"}>
                                                        <CardBody>
                                                            <h5 className="mb-3 text-green fw-bold">{t('adminLabel.assignOrg')} (LEAB)</h5>
                                                            <Row>
                                                                {orgLeabList.map((item) => {
                                                                    if (requestAssignOrg !== null && requestAssignOrg.orgIds && requestAssignOrg.orgIds.length > 0 && requestAssignOrg.orgIds.indexOf(item.id) !== -1) {
                                                                        setTimeout(() => {
                                                                            $(`#name${item.id}`).prop('checked', true);
                                                                        }, 250);
                                                                    }
                                                                    return (
                                                                        <div className="col-6">
                                                                            <Label>
                                                                                <Input id={`name${item.id}`} type="checkbox" name="name" value={item.id} onChange={(e) => HandleClickAssignOrg(e)} />
                                                                                <span className="ms-2">{item.name}</span>
                                                                            </Label>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </Row>
                                                            <div className="text-end">
                                                                <span id="spinnerAssignOrg" className="me-3 d-none">
                                                                    {t('validationMessage.assigningOrgs')} <Spinner color='success'/>
                                                                </span>
                                                                <CustomSubmitButton id="submitAssignOrg" text={t("button.assign")} icon="bx bx-send pe-2"
                                                                                    customClick={async () => {
                                                                                        $("#submitAssignOrg").prop('disabled', true);
                                                                                        $("#spinnerAssignOrg").removeClass("d-none");
                                                                                        await HandleSubmitAssignOrg();
                                                                                    }}/>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                : ''}
                                                {/* ASSING PRIMARY COSTPLACE */}
                                                {responseCostPlaceList && Object.keys(responseCostPlaceList).length > 0 && permission ?
                                                    <Card className="mb-5 card-backend">
                                                    <CardBody>
                                                        <h5 className="mb-3 text-green fw-bold">{t('adminLabel.assignCostPlaces')}</h5>
                                                        {Object.keys(responseCostPlaceList).map((category) => {
                                                            const displayedCategory = category === "Riks" ? "Regioner och folkrörelse" : category;
                                                            return (
                                                                <div key={category} className="mb-3">
                                                                    <h6>{displayedCategory}</h6>
                                                                    <div className="row">
                                                                        {responseCostPlaceList[category].map(({ id, name }) => {
                                                                            const itemId = id.replace(" ", "");
                                                                            if (
                                                                                assignCostPlaceList &&
                                                                                assignCostPlaceList.primaryCostPlace &&
                                                                                assignCostPlaceList.primaryCostPlace.includes(itemId)
                                                                            ) {
                                                                                setTimeout(() => {
                                                                                    $(`#costPlace${itemId}`).prop("checked", true);
                                                                                }, 250);
                                                                            }
                                                                            return (
                                                                                <div className="col-6" key={id}>
                                                                                    <Label>
                                                                                        <Input
                                                                                            id={`costPlace${itemId}`}
                                                                                            type="checkbox"
                                                                                            name="costPlace"
                                                                                            value={itemId}
                                                                                            onChange={(e) => HandleClickAssignCostPlace(e)}
                                                                                        />
                                                                                        <span className="ms-2">{`${id} - ${name}`}</span>
                                                                                    </Label>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                        <div className="text-end">
                                                            <span id="spinnerAssignCostPlace" className="me-3 d-none">
                                                                {t("validationMessage.assigningCostPlaces")} <Spinner color="success" />
                                                            </span>
                                                            <CustomSubmitButton
                                                                id="submitAssignCostPlace"
                                                                text={t("button.assign")}
                                                                icon="bx bx-send pe-2"
                                                                customClick={async () => {
                                                                    $("#submitAssignCostPlace").prop("disabled", true);
                                                                    $("#spinnerAssignCostPlace").removeClass("d-none");
                                                                    await HandleSubmitAssignCostPlace();
                                                                }}
                                                            />
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                                
                                                    : ''}
                                            </Col>
                                        </Row>
                                        )}
                                    </TabPane>

                                    <TabPane tabId="3">
                                        {showTab3 && <ReportProceedingList userId={idValue} returnPath={completePath} />}
                                    </TabPane>

                                    <TabPane tabId="4">
                                        {showTab4 && <AdminHonorariumList userId={idValue} isSuperAdmin={isSuperAdmin} setActiveTab={setActiveTab} returnPath={completePath} />}
                                    </TabPane>

                                    <TabPane tabId="5">
                                        {showTab5 && <PendingBankTransferList isReadOnly={true} setActiveTab={setActiveTab} />}
                                    </TabPane>

                                    <TabPane tabId="6">
                                        {showTab6 && <AdminHonorariumListHistory userId={idValue} isSuperAdmin={isSuperAdmin} setActiveTab={setActiveTab} returnPath={completePath} />}
                                    </TabPane>

                                    <TabPane tabId="7">
                                        {showTab7 && <BankTransferHistoryList isReadOnly={true} setActiveTab={setActiveTab} />}
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </Row>
                    </Col>
                </>
            ) : (
                ''
            )}
        </>
    );
}